import { AlertTriangle, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

type Props = {
  status: "running" | "error";
  message?: string;
  detail?: string;
  onRetry?: () => void;
  onManual?: () => void;
  runningTitle?: string;
  runningSubtitle?: string;
};

export function RecommendationLoader({
  status,
  message,
  detail,
  onRetry,
  onManual,
  runningTitle,
  runningSubtitle,
}: Props) {
  if (status === "running") {
    return (
      <div className="flex flex-col items-center justify-center gap-3 py-12">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
        <div className="text-sm font-medium">
          {runningTitle ?? "Gerando recomendação de oferta…"}
        </div>
        <div className="text-xs text-muted-foreground">
          {runningSubtitle ??
            "Isso pode levar até um minuto. Estamos avaliando o candidato e calculando a oferta."}
        </div>
      </div>
    );
  }

  return (
    <div
      role="alert"
      className="flex flex-col items-center justify-center gap-3 py-10"
      data-testid="recommendation-error-card"
    >
      <AlertTriangle className="h-8 w-8 text-amber-500" />
      <div className="text-sm font-medium">Não foi possível gerar a recomendação</div>
      {message && (
        <div className="text-xs text-muted-foreground max-w-md text-center">{message}</div>
      )}
      {detail && (
        <div className="text-[11px] text-muted-foreground/70 max-w-md text-center font-mono break-all">
          {detail}
        </div>
      )}
      <div className="flex gap-2 mt-2">
        {onRetry && (
          <Button type="button" variant="default" size="sm" onClick={onRetry}>
            Tentar novamente
          </Button>
        )}
        {onManual && (
          <Button type="button" variant="outline" size="sm" onClick={onManual}>
            Preencher manualmente
          </Button>
        )}
      </div>
    </div>
  );
}
